export enum CashPointsRatio {
  FULLCASH = "full-cash",
  FULLPOINTS = "full-points",
  CASHANDPOINTS = "cash-and-points",
}
